import { createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f71cef5")

_pushScopeId("data-v-6f71cef5")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"toc_ui__reminder_body\" data-v-6f71cef5><div class=\"toc_ui__reminder_title\" data-v-6f71cef5> 温馨提示 </div><div class=\"toc_ui__reminder_cnt\" data-v-6f71cef5><span data-v-6f71cef5>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-6f71cef5><span data-v-6f71cef5>2.检测项目结果仅反映检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-6f71cef5><span data-v-6f71cef5>3.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-6f71cef5><span data-v-6f71cef5>4.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内；<br data-v-6f71cef5></span><span data-v-6f71cef5>5.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；<br data-v-6f71cef5></span><span data-v-6f71cef5>6.268V检测标准符合GB/T 30323-2013国家标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。<br data-v-6f71cef5></span></div></div>", 1)
const _hoisted_3 = { class: "toc_ui__anti_body" }
const _hoisted_4 = { class: "toc_ui__anti_farkurl" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          src: _ctx.state.antiFakeUrl
        }, null, 8, ["src"])
      ]),
      _hoisted_5
    ], 512), [
      [_vShow, _ctx.state.antiFakeUrl && _ctx.state.isShowAntiFake]
    ])
  ]))
})